import { render, staticRenderFns } from "./setting-online-chat-overtime.vue?vue&type=template&id=e0c6b4ce&"
import script from "./setting-online-chat-overtime.vue?vue&type=script&lang=js&"
export * from "./setting-online-chat-overtime.vue?vue&type=script&lang=js&"
import style0 from "./setting-online-chat-overtime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports